import { render, staticRenderFns } from "./UsersEmployeePrivileges.vue?vue&type=template&id=354744da&scoped=true&"
import script from "./UsersEmployeePrivileges.vue?vue&type=script&lang=js&"
export * from "./UsersEmployeePrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354744da",
  null
  
)

export default component.exports